const colors = {
  // mostly change primary and secondary color, don't touch the others
  // don't touch the others if it is not really necessary,
  // these bothh will be enought to adapt the website to the company corporate colors

  // Primary: color is used for Tiltes such as Title in home,
  // PLP departaments or categories, PDP description, you might also like,
  // Blog main title, categories and tag title.
  // Also it is used in buttons of background, paginator background
  primary: '#282828',
  // Seconday: color is used in Details,
  // such as line under title, under main menu.
  secondary: '#fecf0a',
  // Text: It is used for all text blog, articles detail, PDP & PLP (title, price, descriptions)
  text: '#282828',
  // background: It is used for any background,
  // to pass a dark mode website would be convert this color to black and text color to white
  background: '#fff',
  // bgLight: It is used for the tone light grey, should always be kind of grey,
  // this applies in background such as order summary in cart page, etc...
  bgLight: '#f7f7f7',
  // bgMedium: It is used for the tone medium grey, should always be kind of grey,
  // this applies in background such as order page/detail row product, etc...
  bgMedium: '#d1d3d4',
  // bgMediumDark: It is used for dark grey, should always be kind of grey,
  // also as used in cupons (My coupons)
  bgMediumDark: '#9b9b9b',
  // bgDark: It is used for PDP & PLP (type colors)
  bgDark: '#bfbfbf',
  // disabled: It is used for disabled buttons
  disabled: '#9b9b9b',
  // link: It is used for links, Theme01 use same secondaty color, but it can be changed
  link: '#fecf0a',
  // link: It is used for link in registration page, links without color (grey)
  inlineLink: '#414141',
  // hover: It is used for hovers, Theme01 use same secondaty color, but it can be changed
  hover: '#fecf0a',
  // alert: It is used for errors, should always be kind of red, also as negative point (My coupons)
  alert: '#d0021b',
  // active: It is used for pendding, should always be kind of orange,
  // used for pendding orders (My coupons)
  active: '#f1ad4e',
  // success: It is used for success, should always be kind of green,
  // also as positives points (My coupons), complete order
  success: '#2ea500',
  // confirm: It is used for orders/ account as confirm account
  confirm: '#367fa9',
  // facebook: It is used for facebook color, in icons or buttons
  facebook: '#3b5998',
  // overlay: It is used for overlays in Modal,but it is used with 40% of opacity
  overlay: '#000',
}

export default colors
